export const ENVIRONMENT = 'production'
export const SENTRY_DSN =
  'https://4ed567c86b18e29d94131aa71ea984c2@o408587.ingest.us.sentry.io/6175936'
export const IS_PRODUCTION = true
export const FEATURE_TOGGLE_STORAGE_KEY_PREFIX = 'je.pcweb.feature_'
